import { ThreeDots as Loader } from "react-loader-spinner";
import colors from "../../styles/colors";
import { Container, LoaderWrapper, Message } from "./styles";

interface LoadingProps {
  color?: string;
  height?: number;
  width?: number;
  fullScreen?: boolean;
  message?: string;
}

const Loading = ({
  color = colors.primaryLight,
  height = 50,
  width = 50,
  fullScreen = false,
  message,
}: LoadingProps) => {
  return (
    <Container $fullScreen={fullScreen}>
      <LoaderWrapper>
        <Loader color={color} height={height} width={width} />
      </LoaderWrapper>
      {message && <Message>{message}</Message>}
    </Container>
  );
};

export default Loading;
